
if(!customElements.get('custom-recommended-products')){
    class ProductRecommendations extends HTMLElement { 

constructor(){
    super();

    // Install the size-dropdown handler before Oakland's
    // product-form click handler can open the quick-view.
    this.setupSizeDropdown();

    const handleIntersection = (entries, observer) => {

                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);

                fetch(this.dataset.url)
                .then(res => res.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    
                    const recommendations = html.querySelector('custom-recommended-products');

                    if(recommendations && recommendations.innerHTML.trim().length){
                        this.innerHTML = recommendations.innerHTML;
                    }

                    this.swiperContainer = this.querySelector('.swiper-container');

                    this.initSwiper();

                    if(html.querySelector('.swiper-slide')){
                        this.setAttribute('data-loaded',' true');
                    }
                })
                .catch(e=> {
                    console.error(e);
                });
            }

            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }

        initSwiper(){
            if(!this.swiperContainer) return;
            var totalSlides = parseInt(this.swiperContainer.dataset.totalSlides);
            var numPerView = parseInt(this.swiperContainer.dataset.numPerView);
            var slidesPerView = (numPerView && totalSlides > numPerView)? numPerView : totalSlides;
            var loop = false;

            if(totalSlides == 1) return;

            var swiperSettings = {
                init: true,
                initialSlides: 0,
                loop: loop,
                spaceBetween: 30,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    567: {
                        slidesPerView: slidesPerView < 2? slidesPerView : 2
                    },
                    991: {
                        slidesPerView: slidesPerView < 3? slidesPerView : 3
                    },
                    1200: {
                        slidesPerView: slidesPerView
                    }
                },
                observer: true,
                observeSlideChildren: true
            }

            if(this.swiperContainer.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                  el: this.swiperContainer.querySelector('.swiper-pagination')
                }
            }

            if(this.swiperContainer.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                  nextEl: this.swiperContainer.querySelector('.swiper-button-next'),
                  prevEl: this.swiperContainer.querySelector('.swiper-button-prev')
                }
            }

            if(this.swiperContainer.dataset.autoplay == 'true'){
                let speed = this.swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);

            this.swiper.init();
            this.getVisibleSlides();
            this.checkPagination();

            this.swiper.on('slideChange', () => {
                this.getVisibleSlides();
            });

            this.swiper.on('resize' ,() => {
                this.checkPagination();
            });
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }

    setupSizeDropdown() {
        if (this.sizeDropdownInitialized) return;
        this.sizeDropdownInitialized = true;

        this.sizeMenu = document.createElement('div');
        this.sizeMenu.className = 'recommended-size-menu';
        this.sizeMenu.style.cssText = `
            position: fixed;
            z-index: 1000000;
            display: none;
            min-width: 150px;
            padding: 6px;
            background: #fff;
            border-radius: 10px;
            box-shadow: 0 5px 20px rgba(0,0,0,.18);
        `;

        document.body.appendChild(this.sizeMenu);

        this.addEventListener('click', event => {
            const button = event.target.closest(
                '.btn-cart[data-variant="true"]'
            );

            if (!button || !this.contains(button)) return;

            const slide = button.closest(
                '[data-recommended-product-id]'
            );

            const variantData = slide?.querySelector(
                '.recommended-size-variants'
            );

            if (!variantData) return;

            event.preventDefault();
            event.stopImmediatePropagation();

            this.openSizeDropdown(button, variantData);
        }, true);

        document.addEventListener('click', event => {
            if (
                !this.sizeMenu.contains(event.target) &&
                !this.contains(event.target)
            ) {
                this.closeSizeDropdown();
            }
        });

        window.addEventListener('scroll', () => {
            this.closeSizeDropdown();
        }, true);

        window.addEventListener('resize', () => {
            this.closeSizeDropdown();
        });
    }

    openSizeDropdown(button, variantData) {
        let variants;

        try {
            variants = JSON.parse(variantData.textContent);
        } catch (error) {
            console.error('Invalid recommended product variants:', error);
            return;
        }

        this.sizeMenu.innerHTML = '';

        const label = document.createElement('div');
        label.textContent = 'Choose size';
        label.style.cssText =
            'padding:7px 10px;font-size:11px;opacity:.65';

        this.sizeMenu.appendChild(label);

        variants.forEach(variant => {
            const option = document.createElement('button');

            option.type = 'button';
            option.textContent = variant.available
                ? variant.title
                : `${variant.title} — Sold out`;

            option.disabled = !variant.available;

            option.style.cssText = `
                display:block;
                width:100%;
                padding:9px 12px;
                border:0;
                background:transparent;
                text-align:left;
                cursor:pointer;
                font:inherit;
                color:#111;
            `;

            if (!variant.available) {
                option.style.opacity = '.4';
                option.style.cursor = 'not-allowed';
            }

            option.addEventListener('click', () => {
                this.addRecommendedVariant(variant.id, option);
            });

            this.sizeMenu.appendChild(option);
        });

        const rect = button.getBoundingClientRect();

        this.sizeMenu.style.display = 'block';

        const menuWidth = this.sizeMenu.offsetWidth;
        const menuHeight = this.sizeMenu.offsetHeight;

        const left = Math.max(
            8,
            Math.min(rect.left, window.innerWidth - menuWidth - 8)
        );

        const top = rect.bottom + menuHeight + 8 >
            window.innerHeight
            ? rect.top - menuHeight - 8
            : rect.bottom + 8;

        this.sizeMenu.style.left = `${left}px`;
        this.sizeMenu.style.top = `${Math.max(8, top)}px`;
    }

    closeSizeDropdown() {
        if (this.sizeMenu) {
            this.sizeMenu.style.display = 'none';
        }
    }

    async addRecommendedVariant(variantId, button) {
        button.disabled = true;

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    items: [{
                        id: Number(variantId),
                        quantity: 1
                    }]
                })
            });

            const result = await response.json();

            if (!response.ok || result.status) {
                throw new Error(
                    result.description || 'Unable to add item'
                );
            }

            this.closeSizeDropdown();

            const cartPopup = document.querySelector(
                'custom-cart-popup'
            );

            if (
                cartPopup &&
                typeof cartPopup.renderContent === 'function'
            ) {
                const addedItem = Array.isArray(result.items)
                    ? result.items[0]
                    : result;

                cartPopup.renderContent(addedItem);
            }

        } catch (error) {
            console.error(
                'Unable to add recommended apparel:',
                error
            );
            alert(error.message || 'Unable to add item');
        } finally {
            button.disabled = false;
        }
    }

        refresh(){
            fetch(this.dataset.url)
            .then(res => res.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                
                const recommendations = html.querySelector('custom-recommended-products');

                if(recommendations && recommendations.innerHTML.trim().length){
                    this.innerHTML = recommendations.innerHTML;
                }

                this.swiperContainer = this.querySelector('.swiper-container');

                this.initSwiper();

                if(html.querySelector('.swiper-slide')){
                    this.setAttribute('data-loaded',' true');
                }
            })
            .catch(e=> {
                console.error(e);
            })
        }
    }

    customElements.define('custom-recommended-products', ProductRecommendations);
}